import { Pill, type PillColor } from 'components/pill/Pill';

import { PEPPOL_STATUS_LABELS } from '../peppol-status-labels';
import type { PeppolDeliveryStatus } from '../peppol.types';

const PEPPOL_STATUS_COLORS: Record<PeppolDeliveryStatus, PillColor> = {
  NotSent: 'neutral',
  Created: 'warning',
  Sent: 'info',
  Delivered: 'positive',
  Refused: 'negative',
  Failed: 'negative',
};

export const PeppolStatusPill: React.FC<{ status: PeppolDeliveryStatus }> = ({ status }) => {
  return (
    <Pill color={PEPPOL_STATUS_COLORS[status]} size="sm">
      {PEPPOL_STATUS_LABELS[status]}
    </Pill>
  );
};
